// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"23fcffc2","749":"427810b6","903":"ee1f5414"}[chunkId] + ".chunk.js";
};